import React, { useEffect, useContext} from 'react';
import * as S from './styles';
import {Context} from '../../services/contexts/StateContext';
// COMPONENTES---------
import {ListaItemBD} from '../ListarPesquisas/listaItemBD';


//----------------------------------------------------
export function Add_ItensLS(props){  
    const {state, dispatch} = useContext(Context);  
    const {listaPesquisa} = state.parametros;  

    // ------------------------------------- 
    function Func_selectItem(item){
        dispatch({
            type: 'set_ListaPesquisa',
            payload: {
                ...listaPesquisa, 
                listaItem:[],
                nomeItem:'',
                selectItem: item ? item : listaPesquisa.nomeItem
            }
        });
    };

    // ####################################################
    return(
        <S.bodyAdd>
            {props.clickNovoItem ?
            <div style={{'display':"flex",'flex':'1',"flexDirection":'column',"justifyContent":"flex-end"}}>
                <S.NovaDespesa>
                    <div style={{"display":"flex", 'minWidth':'90px', "flexDirection":"column",'position':"relative", 'marginRight':"10px"}}>
                        <span>Novo Item:</span>
                        <input 
                        autoFocus 
                        style={{"display":"flex",'width':"100%", 'minHeight':"25px", "color":"black"}}
                        type='search'
                        placeholder='minimo 3 letras'
                        value={props.nomeItem}
                        onChange={e=> props.setItem('nomeItem', e.target.value)}>
                        </input>  

                        {listaPesquisa.listaItem.length > 0 &&
                        <ListaItemBD
                        Cadastro={true}
                        listaItem={listaPesquisa.listaItem}
                        Func_selectItem={Func_selectItem}
                        />
                        } 
                    </div>

                    {listaPesquisa.novoItem.length >= 3?
                    <button 
                    className='bottonAdd'
                    onClick={()=> props.AddItem()}
                    >
                        add
                    </button>
                    :
                    <button 
                    className='bottonAdd'
                    style={{"backgroundColor":"red","color":"white"}} 
                    onClick={()=>props.setdisplayItem(false)}
                    >
                        X
                    </button>
                    }
                    
                </S.NovaDespesa>     
            </div>

            :
            
            <>
            <div 
            style={{ display: "flex", width: "100%", 'flexDirection': "column", margin: "0 5px" }}
            onClick={() => props.EditarSelect()}
            >
                <span>Descrição:</span>
                <div className='intemSelect'>
                    {props.itemSelect}
                </div>
            </div>

            <div style={{display:"flex",'minWidth':'100px', 'flexDirection':"column"}}>
                <span>Valor</span>
                <input 
                style={{"color":"black",'height':"27px"}} 
                type="number"
                value={props.valorItem}
                onChange={e=>props.setItem("valorItem",parseFloat(e.target.value))}>
                </input>   
            </div> 

            <div style={{'display':"flex",position:"relative", alignItems:"flex-end"}}>
                <button
                className='bottonAdd'
                onClick={()=> props.Adicionar()}>
                    salvar
                </button>
            </div>
            </>
            }
        </S.bodyAdd>
)};